var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isActive)?_c('div',{staticClass:"invoice-details"},[_c('div',{staticClass:"invoice-details__overlay",class:{ show: _setup.isActiveUi },on:{"click":function($event){return _setup.hideDrawer()}}}),_c('div',{staticClass:"invoice-details__body",class:{ show: _setup.isActiveUi }},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }